<template>
    <div class="indexContent">
        <div class="indexTop">
            <div class="itSpb spb">
                <div class="indexNavContnet">
                    <div class="indexNavBox" v-for="(item,index) in categoryData.nav" :key="index">
                        <div class="indexNavTitle">{{ item.name }}</div>
                        <div class="indexNavList">
                            <div class="indexNav" v-for="(el,i) in item.list" :key="i" @click="categoryTap(el.url)">{{ el.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="indexBanner">
                    <el-carousel height="460px">
                        <el-carousel-item v-for="(el,index) in categoryData.banner" :key="index">
                            <el-image :src="el.img" fit="cover" class="banner" @click="categoryTap(el.url)"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="indexNavContnet">
                    <div class="headBox center">
                        <el-image :src="userDetail == 0 ? require('@/assets/icon/head.png') : userDetail.avatar" fit="cover" class="head"></el-image>
                    </div>
                    <div class="indexWelcome">欢迎来到{{ categoryData.name }}</div>
                    <div class="loginTips">{{ userDetail == 0 ? '登录后可享受更多权益' : '登录成功' }} </div>
                    <div class="indexBtnBox spb">
                        <div class="indexBtn loginBtn" @click="getLogin" v-if="userDetail == 0">登录</div>
                        <div class="indexBtn loginBtn" @click="getMy" v-else>我的订单</div>
                        <div class="indexBtn settleBtn" @click="settleBtnTap">入驻服务商</div>
                    </div>
                    <div class="announcement">
                        <div class="announcementTop spb">
                            <div class="announcementTitle">市场公告</div>
                            <div class="align" @click="getNotice">
                                <div class="anMore">更多</div>
                                <img src="../assets/icon/more.png" class="anMoreIcon">
                            </div>
                        </div>
                        <div class="announcementItem" v-for="(item,index) in categoryData.notice" :key="index" @click="noticeTap(item.id)">{{ item.title }}</div>
                    </div>
                </div>
            </div>
            <!-- 数据统计 -->
            <div class="statisticsList spb">
                <div class="statistics" v-for="(item,index) in statisticsData" :key="index">
                    <div class="staTitle">{{ item.name }}</div>
                    <div class="staAlign">
                        <div class="staNum">{{ item.value }}</div>
                        <div class="staUnit">{{ item.unit }}</div>
                    </div>
                    <img src="../assets/icon/statistics.png" class="statisticsIcon">
                </div>
            </div>
        </div>
        <!-- 视频号功能 -->
        <div class="indexModule">
            <div class="moduleTitleBox spb">
                <div class="align">
                    <img src="../assets/icon/moduleTitle01.png" class="moduleTitleIcon">
                    <div class="moduleTitle">视频号功能</div>
                </div>
            </div>
            <useList :useData="useData"></useList>
        </div>
        <!-- 视频号服务 -->
        <div class="indexModule">
            <div class="moduleTitleBox spb">
                <div class="align">
                    <img src="../assets/icon/moduleTitle02.png" class="moduleTitleIcon">
                    <div class="moduleTitle">视频号服务</div>
                    <div class="moduleTitleTips">视频号服务、AI智能挑选、源头出货方、服务千万创作者</div>
                </div>
                <div class="align" @click="serviceMore">
                    <div class="moduleMore">查看全部</div>
                    <img src="../assets/icon/more.png" class="moduleMoreIcon">
                </div>
            </div>
            <service :serviceList="serviceList.list"></service>
        </div>
        <!-- 视频号选品库 -->
        <div class="indexModule">
            <div class="moduleTitleBox spb">
                <div class="align">
                    <img src="../assets/icon/moduleTitle03.png" class="moduleTitleIcon">
                    <div class="moduleTitle">视频号选品库</div>
                    <div class="moduleTitleTips">中老年供应链、招商定向高佣！众多达人跑品、AI摒弃垃圾品</div>
                </div>
            </div>
            <div class="libraryTabBox">
                <div :class="['libraryTab',active == index ? 'libraryTabOn' : '']" v-for="(item,index) in libraryTabData" :key="index" @click="libraryTap(index)">{{ item.catename }}</div>
            </div>
            <goodsList :goodsList="goodsList.list"></goodsList>
            <div class="pageBox">
                <el-pagination background layout="prev, pager, next" :page-size="25" :total="goodsList.count" @current-change="currentPage"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                userDetail: 0,
                loginShow: false,
                categoryData: {},
                statisticsData: [],
                useData: [
                    {
						img: require('@/assets/icon/nav01.png'),
						title: '直播裂变红包',
						tips: '红包裂变',
						num: '2162',
						url: '/guide/guide',
                        type: '4'
					},
					{
						img: require('@/assets/icon/nav02.png'),
						title: '视频号下载',
						tips: '二次创作',
						num: '2356',
						url: '/guide/download'
					},
                    {
						img: require('@/assets/icon/nav03.png'),
						title: '当天入驻',
						tips: '无需资质',
						num: '986',
						url: '/guide/guide',
                        type: '1'
					},
                    {
						img: require('@/assets/icon/nav04.png'),
						title: '全包开店',
						tips: '上选品中心',
						num: '2386',
						url: ''
					},
					{
						img: require('@/assets/icon/nav05.png'),
						title: '直播分销',
						tips: '转发赚佣金',
						num: '265',
						url: '/guide/guide',
                        type: '2'
					},
					{
						img: require('@/assets/icon/nav06.png'),
						title: '订单复购',
						tips: '短信复唤',
						num: '365',
						url: ''
					},
                    {
						img: require('@/assets/icon/nav07.png'),
						title: '热门短剧CPS',
						tips: '高额佣金',
						num: '365',
						url: '/service/detail?id=78'
					}
                ],
                serviceList: {},
                active: 0,
                libraryTabData: [{id: 0, catename: "全部", cateimg: "", sort: 0}],
                page: 1,
                goodsList: []
            }
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getBrisk()
            this.getCategory()
            this.getServiceList()
            this.getAPPTitle()
            this.getIndexCategory()
        },
        methods: {
            // 获取首页自定义
            getIndexCategory(){
                this.request.get("index/index/category",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.categoryData = res.data
                })
            },
            // 获取页面标题
            getAPPTitle(){
                this.request.get("index/index/title",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    document.title = res.data.title
                })
            },
            // 获取活跃数据
            getBrisk(){
                this.request.get("index/index/huoyue",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.statisticsData = res.data
                })
            },
            // 获取选品库分类
            getCategory(){
                this.request.get("index/goods/category",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.libraryTabData.push(...res.data)
                    this.getGoodsList()
                })
                .catch(err=>{
                    console.log(err)
                })
            },
            // 获取选品库商品
            getGoodsList(){
                this.request.get("index/goods/goodslist",{
                    params:{
                        page: this.page,
                        pagesize: '25',
                        cate: this.libraryTabData[this.active].id
                    }
                })
                .then(res=>{
                    this.goodsList = res.data
                })
            },
            // 获取服务列表
            getServiceList(){
                this.request.get("index/fuwu/fuwulist",{
                    params:{
                        page: 1,
                        pagesize: '20'
                    }
                })
                .then(res=>{
                    this.serviceList = res.data
                })
            },
            // 翻页
            currentPage(e){
                this.page = e
                this.getGoodsList()
            },
            // tab切换
            libraryTap(e){
                this.active = e
                this.page = 1
                this.getGoodsList()
            },
            // 跳转服务列表
            serviceMore(){
                this.$router.push({ path:'/service/list' })
            },
             // 跳转我的订单
             getMy(){
                this.$router.push({ path:'/my/my', query:{type: 'order'} })
            },
            // 跳转登录
            getLogin(){
                this.$router.push({ path:'/login/login' })
            },
            // 自定义跳转
            categoryTap(e){
                this.$router.push({ path:e })
            },
            // 入驻服务商跳转
            settleBtnTap(){
                window.location.href = this.categoryData.ruzhu
            },
            // 跳转更多公告
            getNotice(){
                this.$router.push({ path:'/notice/notice' })
            },
            // 跳转公告详情
            noticeTap(e){
                this.$router.push({ path:'/notice/noticeDetail', query:{id: e} })
            }
        }
    }
</script>
<style lang="less" scoped>
    .indexContent{
        background: #FAFBFC;
        padding-bottom: 85px;
        .indexTop{
            width: 100vw;
            padding: 22px 0;
            background: url(../assets/image/indexBg.png) no-repeat left top/378px 221px,linear-gradient(to right, #F3F4F9, #EEF1F8);
            .itSpb{
                width: 1200px;
                margin: 0 auto;
                .indexNavContnet{
                    width: 214px;
                    height: 458px;
                    padding: 0 18px;
                    background: #fff;
                    border-radius: 10px;
                    border: 1px solid #E2EAFA;
                    .indexNavBox{
                        margin-top: 24px;
                        .indexNavTitle{
                            font: 16px/16px "Microsoft YaHei";
                            color: #464646;
                        }
                        .indexNavList{
                            padding-top: 6px;
                            display: flex;
                            flex-wrap: wrap;
                            .indexNav{
                                font: 12px/12px "Microsoft YaHei";
                                color: #8A8A8A;
                                padding: 0 12px;
                                border-right: 1px solid #CECECF;
                                margin-top: 5px;
                                cursor: pointer;
                                &:last-child{
                                    border: none;
                                }
                                &:first-child{
                                    padding-left: 0;
                                }
                            }
                        }
                    }
                    .headBox{
                        width: 62px;
                        height: 62px;
                        border-radius: 50%;
                        overflow: hidden;
                        border: 1px solid #FF6A00;
                        margin: 38px 75px 0 75px;
                        .head{
                            width: 62px;
                            height: 62px;
                        }
                    }
                    .indexWelcome{
                        font: 18px/18px "Microsoft YaHei";
                        color: #464646;
                        text-align: center;
                        margin-top: 18px;
                    }
                    .loginTips{
                        font: 14px/14px "Microsoft YaHei";
                        color: #8A8A8A;
                        text-align: center;
                        margin-top: 12px;
                    }
                    .indexBtnBox{
                        margin-top: 19px;
                        .indexBtn{
                            width: 102px;
                            height: 30px;
                            border-radius: 4px;
                            font: 14px/30px "Microsoft YaHei";
                            text-align: center;
                            cursor: pointer;
                            border: 1px solid #FF6A00;
                        }
                        .loginBtn{
                            background: #FF6A00;
                            color: #fff;
                        }
                        .settleBtn{
                            color: #FF6A00;
                        }
                    }
                    .announcement{
                        margin-top: 38px;
                        .announcementTop{
                            padding: 7px 0;
                            .announcementTitle{
                                font: 16px/16px "Microsoft YaHei";
                                color: #202121;
                            }
                            .anMore{
                                font: 14px/16px "Microsoft YaHei";
                                color: #FF6A00;
                                padding-right: 5px;
                                cursor: pointer;
                            }
                            .anMoreIcon{
                                width: 5px;
                                height: 9px;
                                cursor: pointer;
                            }
                        }
                        .announcementItem{
                            font: 14px/24px "Microsoft YaHei";
                            color: #7F7F7F;
                            margin: 4px 0;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            cursor: pointer;
                        }
                    }
                }
                .indexBanner{
                    width: 679px;
                    height: 460px;
                    .banner{
                        width: 679px;
                        height: 460px;
                        cursor: pointer;
                    }
                }
            }
            .statisticsList{
                width: 1200px;
                margin: 0 auto;
                padding-top: 18px;
                .statistics{
                    width: 302px;
                    height: 147px;
                    background: url(../assets/image/statisticsBg.png) no-repeat center/cover;
                    position: relative;
                    .staTitle{
                        font: 16px/16px "Microsoft YaHei";
                        color: #6D6D6D;
                        margin: 35px 0 0 35px;
                    }
                    .staAlign{
                        display: flex;
                        align-items: center;
                        margin: 16px 0 0 35px;
                        color: #484848;
                        .staNum{
                            font: bold 26px/26px "Microsoft YaHei";
                            padding-right: 5px;
                        }
                        .staUnit{
                            font: 18px/26px "Microsoft YaHei";
                        }
                    }
                    .statisticsIcon{
                        width: 87px;
                        height: 21px;
                        position: absolute;
                        right: 21px;
                        bottom: 16px;
                    }
                }
            }
        }
        .indexModule{
            width: 1164px;
            padding: 28px 18px;
            margin: 20px auto 0 auto;
            background: #fff;
            border-radius: 10px;
            .moduleTitleBox{
                .moduleTitleIcon{
                    width: 37px;
                    height: 37px;
                }
                .moduleTitle{
                    font: 22px/22px "Microsoft YaHei";
                    color: #414141;
                    padding: 0 7px;
                }
                .moduleTitleTips{
                    padding: 0 12px;
                    height: 39px;
                    font: 14px/39px "Microsoft YaHei";
                    color: #FF6A00;
                    background: #FFF5EE;
                    border-radius: 6px;
                }
                .moduleMore{
                    font: 14px/39px "Microsoft YaHei";
                    color: #515151;
                    padding-right: 6px;
                    cursor: pointer;
                }
                .moduleMoreIcon{
                    width: 5px;
                    height: 9px;
                    cursor: pointer;
                }
            }
            .libraryTabBox{
                display: flex;
                align-items: center;
                margin-top: 10px;
                .libraryTab{
                    font: 15px/18px "Microsoft YaHei";
                    color: #3E3E3E;
                    padding: 10px 0;
                    margin: 0 20px;
                    cursor: pointer;
                }
                .libraryTabOn{
                    font: 18px/18px "Microsoft YaHei";
                    color: #FF6A00 !important;
                    padding: 10px 0 7px 0;
                    border-bottom: 3px solid #FF6A00;
                }
            }
        }
    }
</style>